/** Reports > Periodical Dispatch: its filters live in the URL so the view can be shared. */
import { DISPATCH_REPORTS } from "@nexseed/shared";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { PeriodReportPage } from "@/features/reports/period-report-page";
import { reportSearch } from "@/features/warehouse/reports/api";

export const Route = createFileRoute("/_app/reports/dispatch/periodical")({
  validateSearch: reportSearch,
  beforeLoad: () => {
    if (!useAuth.getState().can("qc.reports.periodical_dispatch"))
      throw redirect({ to: "/reports" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return (
    <PeriodReportPage
      def={DISPATCH_REPORTS["dispatch-periodical"]}
      path="/reports/dispatch/periodical"
      fileName="periodical-dispatch.xlsx"
      facilityId={selected?.id}
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
